module.exports = __webpack_public_path__ + "static/media/oc-book.b522ef9d.jpg";